import { Container, Image, Row, Col } from 'react-bootstrap';

import { Card } from 'react-bootstrap';
import 'holderjs';
import '../css/GameCard.css';



type GameCardProps = {
    imgPath: string,
    title: string,
    gameURL: string,
    description: string,
    playURL: string,
    playImage: string,
    colsize: string //col-4
}

function GameCard({ imgPath, title, description, playURL, gameURL, playImage, colsize }: GameCardProps) {

    let gameCardStyle = {
        background: 'linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1) ),url(' + imgPath + ')',
        backgroundSize: 'cover'
    };

    let classes = colsize + " card-container m-2 pt-5"

    return <Col className={classes} style={gameCardStyle} >

        <h4 className="card-container-title"  >{title}</h4>
        <div className="mt-3">{description}</div>
        <a href={playURL} target="_blank"><Image className="game-card-playstore" src={playImage} /></a>
    </Col >

}

export default GameCard;
